export const ALLOCATE_TO_EXPERIMENT = 'allocate_to_briefs_experiment';
export const REDIRECT_TO_PAGE = 'create_brief_page';
